var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from 'react';
import { message } from 'antd';
import { path, pathOr } from 'ramda';
import config from 'constants/config';
import useInteractionCreate from 'apollo/mutations/Interactions/CREATE_INTERACTION';
import useInteractionUpdate from 'apollo/mutations/Interactions/UPDATE_INTERACTION';
import useUserStore from 'stores/user';
import { CallStatus, selectActiveAiCalls, selectDrafts, useCarePlanDraftStore } from 'stores/carePlanDraft';
var fetchCallStatus = function (callId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(config.AI_BASE_URL, "/provider-call/").concat(callId), {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json'
                        }
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    message.error('Failed to poll call status');
                    return [2 /*return*/, {
                            status: 'error',
                            data: {
                                status: CallStatus.ERROR,
                                disconnection_reason: 'Cannot reach AI service',
                                call_id: ''
                            }
                        }];
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                e_1 = _a.sent();
                message.error('Error while polling call status');
                console.error('Polling error:', e_1);
                return [2 /*return*/, {
                        status: 'error',
                        data: {
                            status: CallStatus.ERROR,
                            disconnection_reason: 'Cannot reach AI service',
                            call_id: ''
                        }
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var useProviderCallStatusWatcher = function (_a) {
    var interval = _a.interval;
    var updateDraft = useCarePlanDraftStore(selectDrafts).updateDraft;
    var _b = useCarePlanDraftStore(selectActiveAiCalls), activeAiCalls = _b.activeAiCalls, removeActiveAiCall = _b.removeActiveAiCall;
    var onInteractionUpdate = useInteractionUpdate().onInteractionUpdate;
    // Keep latest state/handlers in a ref so the interval effect depends ONLY on
    // `interval`. This stops the effect tearing down + firing an immediate poll on
    // every store change, which previously caused a runaway fetch loop.
    var latest = useRef({ activeAiCalls: activeAiCalls, removeActiveAiCall: removeActiveAiCall, updateDraft: updateDraft, onInteractionUpdate: onInteractionUpdate });
    latest.current = { activeAiCalls: activeAiCalls, removeActiveAiCall: removeActiveAiCall, updateDraft: updateDraft, onInteractionUpdate: onInteractionUpdate };
    var inFlight = useRef(new Set());
    useEffect(function () {
        var cancelled = false;
        var pollCall = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var response, callStatus, isError, isFinished, callDuration, err_1;
            var _c, _d, _e, _f, _g, _h, _j, _k;
            var draftId = _b.draftId, providerId = _b.providerId, callId = _b.callId, interactionId = _b.interactionId;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (cancelled || inFlight.current.has(callId))
                            return [2 /*return*/];
                        inFlight.current.add(callId);
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 8, 9, 10]);
                        return [4 /*yield*/, fetchCallStatus(callId)];
                    case 2:
                        response = _l.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        callStatus = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.status;
                        isError = callStatus === CallStatus.ERROR;
                        isFinished = callStatus !== CallStatus.REGISTERED && callStatus !== CallStatus.ONGOING;
                        if (!isError) return [3 /*break*/, 5];
                        message.error("Provider call failed disconnection_reason: ".concat((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.disconnection_reason));
                        latest.current.removeActiveAiCall(callId);
                        if (!interactionId) return [3 /*break*/, 4];
                        return [4 /*yield*/, latest.current.onInteractionUpdate({
                                id: interactionId,
                                attributes: {
                                    notes: "AI Call verification failed. Disconnection reason: ".concat((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.disconnection_reason)
                                }
                            })];
                    case 3:
                        _l.sent();
                        _l.label = 4;
                    case 4: return [2 /*return*/];
                    case 5:
                        if (!isFinished)
                            return [2 /*return*/];
                        latest.current.removeActiveAiCall(callId);
                        latest.current.updateDraft(draftId, providerId, { ai_call_result: response });
                        callDuration = ((_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.call_cost) === null || _g === void 0 ? void 0 : _g.total_duration_seconds) || 0;
                        if (!interactionId) return [3 /*break*/, 7];
                        return [4 /*yield*/, latest.current.onInteractionUpdate({
                                id: interactionId,
                                attributes: {
                                    minutes_spent: callDuration / 60,
                                    notes: "\n              AI Call verification finished.\n              <br/><br/>Summary: <br/>".concat((_j = (_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.call_analysis) === null || _j === void 0 ? void 0 : _j.call_summary, "\n              <br/><br/>Full transcript:<br/><pre>").concat((_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.transcript, "</pre>\n            ")
                                }
                            })];
                    case 6:
                        _l.sent();
                        _l.label = 7;
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        err_1 = _l.sent();
                        console.error("Polling failed for ".concat(callId), err_1);
                        return [3 /*break*/, 10];
                    case 9:
                        inFlight.current.delete(callId);
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        var tick = function () { return latest.current.activeAiCalls.forEach(pollCall); };
        tick();
        var id = setInterval(tick, interval);
        return function () {
            cancelled = true;
            clearInterval(id);
        };
    }, [interval]);
};
export var useProviderCall = function (ticketId, draftId, providerId) {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useCarePlanDraftStore(selectDrafts), drafts = _b.drafts, updateDraft = _b.updateDraft;
    var addActiveAiCall = useCarePlanDraftStore(selectActiveAiCalls).addActiveAiCall;
    var userId = useUserStore(function (s) { return s.userId; });
    var onInteractionCreate = useInteractionCreate().onInteractionCreate;
    var aiCallData = path([draftId, providerId, 'ai_call_result'], drafts);
    var providerCallState = pathOr('', ['data', 'status'], aiCallData);
    var providerFormData = path([draftId, providerId, 'form_data'], drafts);
    var isCallInProgress = providerCallState === CallStatus.REGISTERED || providerCallState === CallStatus.ONGOING;
    var initiateProviderCall = function (params) { return __awaiter(void 0, void 0, Promise, function () {
        var response, errorMessage, errorData, _a, _b, data, status, interactionResult, interactionId, e_2, errorMessage;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setIsLoading(true);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 12, 13, 14]);
                    return [4 /*yield*/, fetch("".concat(config.AI_BASE_URL, "/provider-call"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json'
                            },
                            body: JSON.stringify(params)
                        })];
                case 2:
                    response = _e.sent();
                    if (!!response.ok) return [3 /*break*/, 7];
                    errorMessage = 'Failed to initiate provider call';
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, response.json()];
                case 4:
                    errorData = _e.sent();
                    errorMessage = errorData.message || errorData.error || errorMessage;
                    return [3 /*break*/, 6];
                case 5:
                    _a = _e.sent();
                    if (response.status === 500) {
                        errorMessage =
                            'Provider call service is temporarily unavailable. Please try again later.';
                    }
                    else if (response.status === 404) {
                        errorMessage = 'Provider call endpoint not found.';
                    }
                    else if (response.status >= 400 && response.status < 500) {
                        errorMessage = 'Invalid request to provider call service.';
                    }
                    return [3 /*break*/, 6];
                case 6:
                    message.error(errorMessage);
                    console.error("Provider call API error: ".concat(response.status, " - ").concat(errorMessage));
                    return [2 /*return*/, null];
                case 7: return [4 /*yield*/, response.json()];
                case 8:
                    _b = _e.sent(), data = _b.data, status = _b.status;
                    if (!(status === 'success')) return [3 /*break*/, 10];
                    updateDraft(draftId, providerId, {
                        ai_call_result: {
                            status: status,
                            data: {
                                call_id: data.call_id,
                                status: CallStatus.REGISTERED
                            }
                        }
                    });
                    return [4 /*yield*/, onInteractionCreate({
                            attributes: {
                                ticket_id: ticketId,
                                contact_detail: params.to_number,
                                contact_name: params.physician_name,
                                created_at: new Date().toISOString(),
                                navigator_id: userId,
                                direction: "outbound",
                                interacted_with: "provider",
                                interaction_modality: "phonecall",
                                minutes_spent: 0,
                                notes: "AI Call verification initiated."
                            }
                        })];
                case 9:
                    interactionResult = (_e.sent()).r;
                    interactionId = (_d = (_c = interactionResult === null || interactionResult === void 0 ? void 0 : interactionResult.data) === null || _c === void 0 ? void 0 : _c.createInteraction) === null || _d === void 0 ? void 0 : _d.id;
                    addActiveAiCall({ interactionId: interactionId, draftId: draftId, providerId: providerId, callId: data.call_id });
                    return [3 /*break*/, 11];
                case 10:
                    message.error('Provider call service request failed.');
                    _e.label = 11;
                case 11: return [3 /*break*/, 14];
                case 12:
                    e_2 = _e.sent();
                    errorMessage = 'Unable to connect to provider call service';
                    if (e_2.name === 'TypeError' && e_2.message.includes('fetch')) {
                        errorMessage = 'Network error: Unable to reach provider call service';
                    }
                    else if (e_2.message) {
                        errorMessage = "Provider call service error: ".concat(e_2.message);
                    }
                    message.error(errorMessage);
                    console.error('Provider call service error:', e_2);
                    return [2 /*return*/, null];
                case 13:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 14: return [2 /*return*/];
            }
        });
    }); };
    return {
        initiateProviderCall: initiateProviderCall,
        isLoading: isLoading || isCallInProgress,
        aiCallData: aiCallData,
        providerFormData: providerFormData
    };
};
